import { FC } from 'react';

import { IAuthTypeForm } from '../../auth.interface';

import styles from './AuthHeader.module.sass';

const AuthHeaderDescr: FC<IAuthTypeForm> = ({ type }) => {
  return (
    <>
      {type === 'phone' && (
        <p className={styles.description}>
          Мы отправим код или позвоним. Отвечать на звонок не нужно. Код может
          прийти на почту или в СМС
        </p>
      )}
      {type === 'email' && (
        <p className={styles.description}>
          Только для зарегистрированных пользователей
        </p>
      )}
    </>
  );
};

export default AuthHeaderDescr;
